(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iurop-faq-band"] && !Shopify.designMode) return;
  try {
    
/* Kleos — acordeón de la banda de FAQs */
(function () {
  'use strict';
  if (window.__iuropFaqBandInit) return;
  window.__iuropFaqBandInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-faq-toggle]');
    if (!btn) return;
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    var answer = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    if (answer) answer.hidden = expanded;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iurop-pdp-resenas"] && !Shopify.designMode) return;
  try {
    
/* Indicador de líneas del carrusel de reseñas (solo móvil) */
document.querySelectorAll('[data-iurop-resenas]').forEach(function (section) {
  var track = section.querySelector('[data-resenas-track]');
  var dashes = section.querySelectorAll('[data-resenas-dash]');
  if (!track || !dashes.length) return;
  var sync = function () {
    var max = track.scrollWidth - track.clientWidth;
    var ratio = max > 0 ? track.scrollLeft / max : 0;
    var active = Math.round(ratio * (dashes.length - 1));
    dashes.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
  };
  track.addEventListener('scroll', sync, { passive: true });
  sync();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iurop-whatsapp"]) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.waReady) return;
    root.dataset.waReady = '1';
    var link = root.querySelector('.iurop-whatsapp__link');
    if (!link) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var timer;
    function setOpen(open) {
      root.classList.toggle('is-open', open);
      link.setAttribute('aria-expanded', open ? 'true' : 'false');
      clearTimeout(timer);
      if (open) timer = setTimeout(function () { setOpen(false); }, 8000);
    }
    link.addEventListener('click', function (e) {
      if (!mq.matches || root.classList.contains('is-open')) return;
      e.preventDefault();
      setOpen(true);
    });
    document.addEventListener('click', function (e) {
      if (root.classList.contains('is-open') && !root.contains(e.target)) setOpen(false);
    });
    /* Se aparta del sticky ATC: sube lo que mide la barra + su separacion. */
    function lift() {
      var bar = document.getElementById('IuropStickyAtc');
      var on = bar && document.body.classList.contains('iurop-sticky-atc-visible');
      var h = on ? bar.offsetHeight + (parseFloat(getComputedStyle(bar).bottom) || 0) : 0;
      root.style.setProperty('--wa-lift', h + 'px');
    }
    new MutationObserver(lift).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', lift);
    lift();
  }
  init(document.querySelector('[data-iurop-wa]'));
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-iurop-wa]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
/* ==========================================================================
   Kleos — Página de carrito: stepper +/− como mejora progresiva.
   Auto-envía el form NATIVO (updates[]) apuntando al botón "Actualizar";
   sin JS, el input numérico + "Actualizar carrito" siguen funcionando.
   No depende del JS del drawer (#CartDrawer).
   ========================================================================== */
(function () {
  'use strict';

  function initCartPage(root) {
    if (root.__iuropCartpInit) return;
    root.__iuropCartpInit = true;

    var form = root.querySelector('form');
    if (!form) return;
    var updateBtn = form.querySelector('button[name="update"]');

    function submitUpdate() {
      if (updateBtn && form.requestSubmit) form.requestSubmit(updateBtn);
      else form.submit();
    }

    root.querySelectorAll('[data-cartp-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-cartp-qty]');
        var input = wrap && wrap.querySelector('input[name="updates[]"]');
        if (!input) return;
        var delta = btn.getAttribute('data-cartp-step') === 'up' ? 1 : -1;
        var next = (parseInt(input.value, 10) || 0) + delta;
        if (next < 0) next = 0;
        input.value = next;
        submitUpdate();
      });
    });

    /* Editar la cantidad a mano también aplica al salir del campo */
    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'updates[]') submitUpdate();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-iurop-cartp]').forEach(initCartPage);
  }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
/* ==========================================================================
   Kleos — PLP: drawer/toggle de filtros, slider de precio de escala
   LOGARÍTMICA con campos € editables (clon del filtro algorítmico de cafeshi)
   y FILTRADO EN VIVO por Section Rendering API (sin recarga, sin botón
   "Ver resultados", que queda como fallback sin JS).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__iuropPlpFilters) return;
  window.__iuropPlpFilters = true;

  var MQ_MOBILE = window.matchMedia('(max-width: 749px)');

  /* Escala LINEAL del slider de precio: la posición del tirador (0..SCALE) mapea
     al precio de forma proporcional, así el punto medio del track es el precio
     medio del recorrido y el desplazamiento es uniforme de punta a punta.
     (Antes era logarítmica —clon de cafeshi—; el cliente pidió lineal.)
     El recorrido es [minP, maxP] — minP = precio del producto MÁS BARATO de la
     colección — en vez de [0, maxP]: pos 0 = minP EXACTO, pos SCALE = maxP EXACTO. */
  var PRICE_SCALE = 1000;
  function priceFromPos(pos, minP, maxP) {
    var span = maxP - minP;
    if (!(span > 0)) return minP > 0 ? minP : 0;
    return Math.round(minP + span * (pos / PRICE_SCALE));
  }
  /* QA R17 · P4a — recorrido DEGENERADO (span 0 = colección de precio único, p.ej.
     termos/marvel: todo al mismo precio). El suelo sigue siendo el precio real, así
     que el tirador MÍNIMO va al extremo izquierdo y el MÁXIMO al derecho; devolver
     0 para ambos dejaba la barra vacía y el tirador máximo pegado a la izquierda. */
  function posFromPrice(price, minP, maxP, isMax) {
    var span = maxP - minP;
    if (!(span > 0)) return isMax ? PRICE_SCALE : 0;
    var delta = price - minP;
    if (delta <= 0) return 0;
    if (delta >= span) return PRICE_SCALE;
    return Math.round(PRICE_SCALE * delta / span);
  }

  /* Formato de precio de Kleos (separador de millar, sin decimales) igualando el
     filtro `money` del tema; el idioma del documento controla la puntuación (multi
     divisa/idioma). Los campos se muestran formateados y se leen con parseNum. */
  function fmtNum(n) {
    try { return Number(n).toLocaleString(document.documentElement.lang || 'es-AR'); }
    catch (e) { return String(n); }
  }
  function parseNum(str) {
    var d = String(str == null ? '' : str).replace(/[^\d]/g, '');
    return d === '' ? NaN : parseInt(d, 10);
  }

  function initPlp(root) {
    if (root.__iuropPlpInit) return;
    root.__iuropPlpInit = true;

    var sectionId = root.getAttribute('data-section-id');
    var toggle = root.querySelector('[data-plp-toggle]');
    var layout = root.querySelector('[data-plp-layout]');
    var panel = root.querySelector('[data-plp-panel]');
    var scrim = root.querySelector('[data-plp-scrim]');
    var closeBtn = root.querySelector('[data-plp-close]');
    var form = root.querySelector('[data-plp-form]');
    var main = root.querySelector('[data-plp-main]');
    var lastFocus = null;
    var scrimTimer = null;
    var priceTimer = null;
    var controller = null;
    var sliders = [];

    function isMobile() { return MQ_MOBILE.matches; }

    /* ---------- Drawer móvil ---------- */
    function openDrawer() {
      if (!panel || panel.classList.contains('is-open')) return;
      if (scrimTimer) { window.clearTimeout(scrimTimer); scrimTimer = null; }
      lastFocus = document.activeElement;
      if (scrim) scrim.hidden = false;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          panel.classList.add('is-open');
          if (scrim) scrim.classList.add('is-open');
        });
      });
      document.body.classList.add('iurop-lock');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer(restoreFocus) {
      /* QA R17 · E3: el signo del toggle (+/−) se deriva de aria-expanded, así que
         hay que resetearlo SIEMPRE, incluso si salimos por el guard de abajo —
         si `is-open` no llegó a aplicarse (el doble rAF no corre en pestañas de
         fondo), el drawer quedaba cerrado pero el toggle seguía en "−". */
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (!panel || !panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open');
      if (scrim) {
        scrim.classList.remove('is-open');
        scrimTimer = window.setTimeout(function () { scrim.hidden = true; }, 300);
      }
      document.body.classList.remove('iurop-lock');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (restoreFocus !== false && lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (isMobile()) {
          openDrawer();
        } else if (layout) {
          var hidden = layout.classList.toggle('filters-hidden');
          toggle.setAttribute('aria-expanded', hidden ? 'false' : 'true');
        }
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', function () { closeDrawer(); });
    if (scrim) scrim.addEventListener('click', function () { closeDrawer(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* aria-expanded según el viewport REAL: el markup nace "false" (drawer móvil
       cerrado); en escritorio la barra lateral es visible salvo filters-hidden. */
    function syncToggleAria() {
      if (!toggle) return;
      if (isMobile()) {
        var open = panel && panel.classList.contains('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      } else {
        var hidden = layout && layout.classList.contains('filters-hidden');
        toggle.setAttribute('aria-expanded', hidden ? 'false' : 'true');
      }
    }
    syncToggleAria();

    var onMq = function () { closeDrawer(false); syncToggleAria(); };
    if (MQ_MOBILE.addEventListener) MQ_MOBILE.addEventListener('change', onMq);
    else if (MQ_MOBILE.addListener) MQ_MOBILE.addListener(onMq);

    /* ---------- URL a partir del estado del formulario ---------- */
    function buildUrl() {
      var params = new URLSearchParams();
      if (form) {
        var fd = new FormData(form);
        fd.forEach(function (value, key) {
          if (value === '' || value == null) return; /* omite params vacíos */
          params.append(key, value);
        });
        /* Los inputs OCULTOS del precio (gte/lte) quedan VACÍOS cuando el tirador
           está en su extremo (rango completo = sin filtro) → FormData ya los omite
           arriba, dejando la URL limpia. */
      }
      /* Tags nativas (Producto/Temática): van en el PATH, no en la query.
         Normalizamos la base a /collections/HANDLE (tolera prefijo de idioma
         y un path que ya traiga tags) y les añadimos las marcadas. */
      var base = (form && form.getAttribute('action')) || window.location.pathname;
      var bm = base.match(/^(.*\/collections\/[^\/?]+)/);
      if (bm) base = bm[1];
      var tags = [];
      if (form) {
        form.querySelectorAll('[data-plp-tag]:checked').forEach(function (c) {
          tags.push(c.getAttribute('data-plp-tag'));
        });
      }
      if (tags.length) base = base + '/' + tags.join('+');
      var url = new URL(base, window.location.origin);
      url.search = params.toString();
      return url.pathname + url.search;
    }

    /* ---------- Render por Section Rendering API (sin recarga) ---------- */
    function renderResults(url, push) {
      if (!main) return;
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;

      /* congela la altura para evitar el salto mientras carga */
      main.style.minHeight = main.offsetHeight + 'px';
      main.classList.add('is-loading');

      var fetchUrl = new URL(url, window.location.origin);
      if (sectionId) fetchUrl.searchParams.set('section_id', sectionId);

      fetch(fetchUrl.toString(), {
        signal: controller ? controller.signal : undefined,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('plp ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          /* del documento re-renderizado cogemos SOLO [data-plp-main]
             (grid + paginación); la sidebar de filtros NO se toca */
          var fresh = doc.querySelector('[data-plp-main]');
          if (fresh) main.innerHTML = fresh.innerHTML;
          main.classList.remove('is-loading');
          main.style.minHeight = '';
          if (push !== false) {
            try { window.history.pushState({ iuropPlp: true }, '', url); } catch (e) {}
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return; /* petición sustituida */
          main.classList.remove('is-loading');
          main.style.minHeight = '';
          window.location.href = url; /* último recurso: navegación normal */
        });
    }
    root.__plpRender = renderResults;
    root.__plpSync = syncControlsFromUrl;

    /* ---------- Reset de controles (para "Limpiar"/"Quitar filtros") ---------- */
    function resetControls() {
      if (!form) return;
      form.querySelectorAll('input[type="checkbox"]').forEach(function (c) { c.checked = false; });
      var defSort = root.getAttribute('data-plp-default-sort');
      if (defSort) {
        var r = form.querySelector('input[type="radio"][name="sort_by"][value="' + defSort + '"]');
        if (r) r.checked = true;
      }
      sliders.forEach(function (s) { s.initFromPrices(s.minP, s.maxP); });
    }

    /* Re-sincroniza los controles de la sidebar con la URL actual (para
       atrás/adelante: el grid se re-renderiza y la barra debe reflejar el
       estado restaurado — checkboxes, orden y slider). */
    function syncControlsFromUrl() {
      if (!form) return;
      var params = new URLSearchParams(window.location.search);
      form.querySelectorAll('input[type="checkbox"]:not([data-plp-tag])').forEach(function (c) {
        c.checked = params.getAll(c.name).indexOf(c.value) !== -1;
      });
      /* Tags (Producto/Temática): se leen del PATH (/collections/HANDLE/tag1+tag2) */
      var tagSeg = (window.location.pathname.match(/\/collections\/[^\/]+\/([^\/?]+)/) || [])[1] || '';
      var curTags = tagSeg ? decodeURIComponent(tagSeg).split('+') : [];
      form.querySelectorAll('[data-plp-tag]').forEach(function (c) {
        c.checked = curTags.indexOf(c.getAttribute('data-plp-tag')) !== -1;
      });
      var sort = params.get('sort_by');
      var defSort = root.getAttribute('data-plp-default-sort');
      var sortR = form.querySelector('input[type="radio"][name="sort_by"][value="' + (sort || defSort) + '"]');
      if (sortR) sortR.checked = true;
      sliders.forEach(function (s) {
        var gte = s.hMin ? params.get(s.hMin.name) : null;
        var lte = s.hMax ? params.get(s.hMax.name) : null;
        s.initFromPrices(gte != null ? parseFloat(gte) : s.minP, lte != null ? parseFloat(lte) : s.maxP);
      });
    }

    /* ---------- Aplicación EN VIVO desde el formulario ---------- */
    function schedulePrice() {
      if (priceTimer) window.clearTimeout(priceTimer);
      priceTimer = window.setTimeout(function () { renderResults(buildUrl(), true); }, 350);
    }

    if (form) {
      /* si por lo que sea se dispara el submit (Enter, botón fallback) → AJAX */
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        renderResults(buildUrl(), true);
        if (isMobile()) closeDrawer();
      });
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t.matches('[data-plp-range]')) {
          var sr = findSlider(t); if (sr) sr.paint();
          schedulePrice();                 /* fetch al SOLTAR el tirador (con debounce) */
        } else if (t.matches('[data-plp-num]')) {
          var sn = findSlider(t); if (sn) sn.applyTyped(true); /* teclado: acota, ordena y fija */
          schedulePrice();
        } else if (t.matches('[data-plp-tag]')) {
          /* Producto/Temática: el filtrado por tag nativo combina con AND — dos
             temáticas a la vez darían 0 resultados → radio por grupo (re-click
             en la marcada la quita). Entre grupos SÍ combinan (Sets + Anime). */
          if (t.checked) {
            var grp = t.closest('[data-plp-tag-group]');
            if (grp) grp.querySelectorAll('[data-plp-tag]').forEach(function (o) { if (o !== t) o.checked = false; });
          }
          renderResults(buildUrl(), true);
        } else if (t.matches('input[type="checkbox"], input[type="radio"], select')) {
          renderResults(buildUrl(), true); /* checkbox/radio/orden: al instante */
        }
      });
      form.addEventListener('input', function (e) {
        var t = e.target;
        if (t.matches('[data-plp-range]')) {          /* arrastre: solo PINTA (sin fetch) */
          var sr = findSlider(t); if (sr) sr.paint();
        } else if (t.matches('[data-plp-num]')) {     /* tecleo: preview en vivo sin fetch */
          var sn = findSlider(t); if (sn) sn.applyTyped(false);
        }
      });
    }

    /* ---------- Delegación en el root (sobrevive al re-render de [data-plp-main]):
       paginación por AJAX + enlaces "Limpiar"/"Quitar filtros" ---------- */
    root.addEventListener('click', function (e) {
      var reset = e.target.closest('.iurop-plp__clear-link, .iurop-plp__empty .btn');
      if (reset && reset.getAttribute('href')) {
        e.preventDefault();
        resetControls();
        renderResults(reset.getAttribute('href'), true);
        return;
      }
      var link = e.target.closest('a.iurop-plp__page, a.iurop-plp__page-arrow');
      if (link && main && main.contains(link)) {
        if (link.classList.contains('is-disabled')) return;
        var href = link.getAttribute('href');
        if (!href) return;
        e.preventDefault();
        renderResults(href, true);
        var y = root.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      }
    });

    /* Encuentra el slider cuyo contenedor engloba al elemento (para la delegación). */
    function findSlider(el) {
      var w = el.closest('[data-plp-price]');
      for (var i = 0; i < sliders.length; i++) if (sliders[i].wrap === w) return sliders[i];
      return null;
    }

    /* ---------- Slider de precio (escala LOGARÍTMICA + campos € editables) ----------
       Clon del filtro algorítmico de cafeshi. Los tiradores corren en espacio de
       POSICIÓN 0..PRICE_SCALE y se mapean a precio con posFromPrice/priceFromPos, de
       modo que la mitad izquierda del track cubre los precios bajos. Los inputs
       OCULTOS (name=…gte/lte) son los que ENVÍAN; se vacían en los extremos → URL limpia. */
    root.querySelectorAll('[data-plp-price]').forEach(function (wrap) {
      var minR = wrap.querySelector('[data-plp-range="min"]');
      var maxR = wrap.querySelector('[data-plp-range="max"]');
      var progress = wrap.querySelector('[data-plp-progress]');
      var nMin = wrap.querySelector('[data-plp-num="min"]');
      var nMax = wrap.querySelector('[data-plp-num="max"]');
      var hMin = wrap.querySelector('[data-plp-input="min"]');
      var hMax = wrap.querySelector('[data-plp-input="max"]');
      var maxP = parseFloat(wrap.getAttribute('data-max')) || 0;
      /* QA R17 · P4a: suelo del recorrido = producto más barato de la colección.
         El guard SOLO descarta lo imposible (NaN, negativo o POR ENCIMA del techo).
         Antes decía `minP >= maxP` y eso tiraba a 0 el suelo de las colecciones de
         precio único (termos/sets/marvel) igual que hacía el Liquid: era el mismo
         bug duplicado en cliente, así que arreglar solo el Liquid no bastaba. */
      var minP = parseFloat(wrap.getAttribute('data-min'));
      if (isNaN(minP) || minP < 0 || minP > maxP) minP = 0;
      if (!minR || !maxR) return;

      /* Pinta la PISTA (fill + inputs ocultos que ENVÍAN) desde la posición de los
         tiradores. NO toca los campos € → nunca pisa lo que el usuario está tecleando. */
      function paintTrack() {
        /* Recorrido degenerado (todos los productos al mismo precio): no hay nada
           que filtrar, así que los tiradores se anclan a los extremos y cualquier
           arrastre vuelve solo — la lectura se queda en el precio real. */
        if (!(maxP - minP > 0)) { minR.value = 0; maxR.value = PRICE_SCALE; }
        var loPos = parseFloat(minR.value) || 0;
        var hiPos = parseFloat(maxR.value); if (isNaN(hiPos)) hiPos = PRICE_SCALE;
        if (loPos > hiPos) { loPos = hiPos; minR.value = loPos; } /* evita que se crucen */
        if (progress) {
          progress.style.left = (loPos / PRICE_SCALE * 100) + '%';
          progress.style.right = (100 - hiPos / PRICE_SCALE * 100) + '%';
        }
        var loPrice = priceFromPos(loPos, minP, maxP);
        var hiPrice = priceFromPos(hiPos, minP, maxP);
        /* envía el precio real; vacía el param cuando el tirador está en su extremo
           (extremo izquierdo = minP, el producto más barato ⇒ no filtra nada) */
        if (hMin) hMin.value = loPrice > minP ? String(loPrice) : '';
        if (hMax) hMax.value = hiPrice < maxP ? String(hiPrice) : '';
        /* si el tirador min queda en la mitad alta, súbelo para poder agarrarlo
           cuando ambos coinciden en el extremo derecho */
        minR.style.zIndex = loPos > PRICE_SCALE / 2 ? '4' : '';
        return { loPrice: loPrice, hiPrice: hiPrice };
      }

      /* Pinta la pista Y espeja el precio en los campos € (arrastre/init/reset),
         sin pisar el campo que el usuario esté editando en ese momento. */
      function paint() {
        var p = paintTrack();
        if (nMin && nMin !== document.activeElement) nMin.value = fmtNum(Math.round(p.loPrice));
        if (nMax && nMax !== document.activeElement) nMax.value = fmtNum(Math.round(p.hiPrice));
      }

      /* Coloca los tiradores desde PRECIOS (init, reset, atrás/adelante) y pinta. */
      function initFromPrices(loP, hiP) {
        if (isNaN(loP)) loP = minP;
        if (isNaN(hiP)) hiP = maxP;
        minR.value = posFromPrice(loP, minP, maxP, false);
        maxR.value = posFromPrice(hiP, minP, maxP, true);
        paint();
      }

      /* Lee los campos € tecleados, los acota a [0,max] y mueve los tiradores.
         commit=true: ORDENA y fija los inputs ocultos con el precio EXACTO tecleado
         (el ida y vuelta logarítmico deriva; el commit no) y refleja los campos
         acotados. commit=false: solo PREVIEW de pista/tiradores, sin tocar los campos
         → el valor que el usuario escribe es siempre soberano. */
      function applyTyped(commit) {
        var lo = parseNum(nMin && nMin.value); if (isNaN(lo)) lo = minP;
        var hi = parseNum(nMax && nMax.value); if (isNaN(hi)) hi = maxP;
        lo = Math.max(minP, Math.min(lo, maxP));
        hi = Math.max(minP, Math.min(hi, maxP));
        if (commit && lo > hi) { var t = lo; lo = hi; hi = t; }
        minR.value = posFromPrice(lo, minP, maxP, false);
        maxR.value = posFromPrice(hi, minP, maxP, true);
        paintTrack();                        /* pista + hidden; los campos NO se tocan aquí */
        if (!commit) return;
        if (hMin) hMin.value = lo > minP ? String(lo) : ''; /* precio EXACTO tecleado */
        if (hMax) hMax.value = hi < maxP ? String(hi) : '';
        if (nMin) nMin.value = fmtNum(Math.round(lo));      /* refleja formateado (Kleos) */
        if (nMax) nMax.value = fmtNum(Math.round(hi));
      }

      initFromPrices(parseFloat(wrap.getAttribute('data-init-min')), parseFloat(wrap.getAttribute('data-init-max')));

      /* La ida y vuelta precio→posición→precio DERIVA (la posición es un entero
         0..1000): con gte=200000 en la URL, paintTrack reescribía el input oculto a
         199662 y la siguiente interacción (ordenar, otro filtro) reenviaba ESE valor,
         moviendo el filtro que el usuario había puesto. Si la URL ya traía un precio
         aplicado se restaura el valor EXACTO; sin filtro los ocultos están vacíos y
         esto no toca nada. */
      var exactMin = wrap.getAttribute('data-init-min');
      var exactMax = wrap.getAttribute('data-init-max');
      if (hMin && hMin.value !== '' && exactMin) {
        hMin.value = exactMin;
        if (nMin && nMin !== document.activeElement) nMin.value = fmtNum(parseFloat(exactMin));
      }
      if (hMax && hMax.value !== '' && exactMax) {
        hMax.value = exactMax;
        if (nMax && nMax !== document.activeElement) nMax.value = fmtNum(parseFloat(exactMax));
      }

      /* El registro que consumen resetControls()/syncControlsFromUrl() se crea ANTES
         del refinado asíncrono: si el fetch baja el suelo hay que actualizar TAMBIÉN
         `api.minP`, porque antes se empujaba una copia del valor viejo y "Limpiar" o
         el botón atrás devolvían el tirador al suelo equivocado. */
      var api = {
        wrap: wrap, minR: minR, maxR: maxR, minP: minP, maxP: maxP,
        hMin: hMin, hMax: hMax,
        paint: paint, initFromPrices: initFromPrices, applyTyped: applyTyped
      };
      sliders.push(api);

      /* QA R17 · P4a — El suelo lo calcula Liquid recorriendo productos, y sus
         arrays topan en 50 items: en una colección más grande el "más barato" puede
         quedar por encima del real. Liquid publica data-floor-partial="1" cuando su
         escaneo NO cubrió la colección entera (productos escaneados < total) — solo
         entonces se pide el JSON público (hasta 250) y se recoloca el tirador.
         Sustituye al gate anterior por `data-count > 50`, que era una suposición del
         mismo tope y no distinguía un escaneo completo de uno truncado.
         FAIL-SAFE: cualquier fallo (endpoint apagado, red, formato) deja el suelo
         que ya pintó Liquid. Límite conocido: colecciones de más de 250 productos
         necesitarían paginar el JSON. */
      var floorPartial = wrap.getAttribute('data-floor-partial') === '1';
      if (floorPartial && 'fetch' in window) {
        var baseUrl = wrap.getAttribute('data-url') || window.location.pathname;
        fetch(baseUrl.replace(/\/$/, '') + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (!data || !data.products || !data.products.length) return;
            var real = Infinity;
            data.products.forEach(function (p) {
              (p.variants || []).forEach(function (v) {
                var n = parseFloat(v.price);
                if (!isNaN(n) && n > 0 && n < real) real = n;
              });
            });
            if (real === Infinity) return;
            var suelo = Math.floor(real);
            if (suelo > maxP || suelo >= minP) return;  /* solo si es MÁS barato */
            /* el precio máximo VIGENTE hay que leerlo con el suelo ANTIGUO, antes de
               moverlo (la conversión posición→precio depende de minP). El bug previo
               llamaba priceFromPos(pos, maxP) sin el 3er argumento → NaN. */
            var hiActual = priceFromPos(parseFloat(maxR.value), minP, maxP);
            minP = suelo;
            api.minP = suelo;
            wrap.setAttribute('data-min', String(suelo));
            /* si el usuario aún no ha tocado el filtro, recoloca el tirador */
            var sinFiltroMin = !hMin || hMin.value === '';
            if (sinFiltroMin) initFromPrices(suelo, hiActual);
          })
          .catch(function () { /* nos quedamos con el suelo de Liquid */ });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-iurop-plp]').forEach(initPlp);
  }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
  /* atrás/adelante del navegador → re-render de la URL actual (sin pushState) */
  window.addEventListener('popstate', function () {
    var root = document.querySelector('[data-iurop-plp]');
    if (!root) return;
    if (root.__plpSync) root.__plpSync();
    if (root.__plpRender) root.__plpRender(window.location.href, false);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faq"] && !Shopify.designMode) return;
  try {
    
/* Acordeón FAQs — delegación (sobrevive recargas de sección en el editor) */
document.addEventListener('click', function (event) {
  var btn = event.target.closest('.iurop-faq__q');
  if (!btn) return;
  var item = btn.closest('.iurop-faq__item');
  if (!item) return;
  var open = item.classList.toggle('is-open');
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-personalizar"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   PDP Personalizar — comportamiento propio de la sección (QA R17, parcela C).
   Convive con assets/iurop-personalizar.js: aquí SOLO vive lo que esa pasada
   no cubre y nada se ata dos veces.
     · C1 galería: track horizontal real (swipe en móvil) + miniaturas que
       navegan + lightbox de la imagen visible. El initGallery() del asset se
       auto-anula porque ya no existe [data-pp-main-img] (sale por su guard).
     · C3 "Leer más": se oculta si la reseña NO llega a recortarse y refleja
       el estado en aria-expanded (el toggle sigue siendo del asset: NO se
       añade un segundo listener de click o se anularían entre sí).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__iuropPpSectionInit) return;
  window.__iuropPpSectionInit = true;

  function all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  /* ---------- C1: galería con swipe ---------- */
  function initGallerySlider(root) {
    var track = root.querySelector('[data-pp-track]');
    if (!track) return;
    var slides = all('[data-pp-gslide]', track);
    var thumbs = all('[data-pp-thumb-btn]', root);
    if (!slides.length) return;

    var lastIndex = -1;

    /* P2a: con más miniaturas de las que caben, la banda scrollea → al cambiar
       de foto se acerca la activa. Se mueve SOLO el eje X de la propia banda
       (nada de scrollIntoView, que arrastraría también la página). */
    function revealThumb(t) {
      var strip = t.parentNode;
      if (!strip || strip.scrollWidth <= strip.clientWidth) return;
      var pad = parseFloat(getComputedStyle(strip).paddingLeft) || 0;
      var view = strip.clientWidth;
      var left = t.offsetLeft - pad;
      var right = t.offsetLeft + t.offsetWidth + pad;
      var target = null;
      if (left < strip.scrollLeft) target = left;
      else if (right > strip.scrollLeft + view) target = right - view;
      if (target === null) return;
      target = Math.max(0, Math.min(target, strip.scrollWidth - view));
      /* en pestaña oculta el scroll suave nativo no avanza → salto directo */
      if (document.hidden) strip.scrollLeft = target;
      else strip.scrollTo({ left: target, behavior: 'smooth' });
    }

    function setActive(i) {
      slides.forEach(function (s, j) { s.classList.toggle('is-current', j === i); });
      thumbs.forEach(function (t, j) {
        var on = j === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
      if (i !== lastIndex) {
        lastIndex = i;
        if (thumbs[i]) revealThumb(thumbs[i]);
      }
    }

    function goTo(i) {
      var idx = Math.max(0, Math.min(i, slides.length - 1));
      var left = slides[idx].offsetLeft - track.offsetLeft;
      /* en pestaña oculta el scroll suave nativo no avanza → salto directo */
      if (document.hidden) track.scrollLeft = left;
      else track.scrollTo({ left: left, behavior: 'smooth' });
      setActive(idx);
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i); });
    });

    var pending = false;
    function sync() {
      var x = track.scrollLeft, idx = 0, best = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs((s.offsetLeft - track.offsetLeft) - x);
        if (d < best) { best = d; idx = i; }
      });
      setActive(idx);
    }
    track.addEventListener('scroll', function () {
      if (document.hidden) { sync(); return; }   // rAF no corre en 2º plano
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; sync(); });
    }, { passive: true });

    /* lightbox de la imagen visible (el asset ya no lo engancha) */
    slides.forEach(function (s) {
      var img = s.querySelector('img');
      if (!img) return;
      img.addEventListener('click', function () {
        if (window.iuropLightbox && window.iuropLightbox.open) {
          window.iuropLightbox.open(s.getAttribute('data-media-id') || null);
        }
      });
    });

    setActive(0);
  }

  /* ---------- C3: "Leer más" solo cuando hay texto que desplegar ---------- */
  function initReadMore(root) {
    all('[data-pp-readmore]', root).forEach(function (btn) {
      var card = btn.closest('[data-pp-review]');
      var text = card && card.querySelector('[data-pp-review-text]');
      if (!card || !text) return;

      function syncNeeded() {
        if (card.classList.contains('is-expanded')) { btn.hidden = false; return; }
        btn.hidden = (text.scrollHeight - text.clientHeight) <= 1;
      }
      /* el toggle de la clase lo hace assets/iurop-personalizar.js: aquí solo
         se espeja en ARIA (un 2º listener de click cancelaría el 1º) */
      new MutationObserver(function () {
        btn.setAttribute('aria-expanded', card.classList.contains('is-expanded') ? 'true' : 'false');
      }).observe(card, { attributes: true, attributeFilter: ['class'] });

      syncNeeded();
      window.addEventListener('resize', syncNeeded, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncNeeded).catch(function () {});
    });
  }

  function init() {
    var root = document.querySelector('[data-iurop-personalizar]');
    if (!root) return;
    initGallerySlider(root);
    initReadMore(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* "+info" de Mercado Pago: abre el banner DENTRO de la página. Delegado en
     document para sobrevivir al re-render del editor de temas. El JS de la PDP
     normal no se carga en esta plantilla, por eso vive aquí también. */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-iurop-mp-toggle]');
    if (!btn) return;
    var id = btn.getAttribute('aria-controls');
    var panel = id ? document.getElementById(id) : null;
    if (!panel) return;
    var open = panel.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   Kleos — PDP · añadidos QA R17 (B5 y B7).
   Va aquí (no en assets/iurop-product.js) porque es lógica exclusiva de esta
   sección. Nivel raíz del fichero, nunca anidado en un condicional Liquid.
   · B5 "Así lo recibes": avance TARJETA A TARJETA por pitch (ancho + gap) y
     dash activo = índice REAL del slide (el genérico usaba una proporción del
     scroll y con el peek móvil se desincronizaba). Este carrusel usa
     data-iurop-vslider* para que el genérico de iurop-product.js no lo toque.
   · B7 "+info" de Mercado Pago: despliega un panel dentro de la página.
   ========================================================================== */
(function () {
  'use strict';

  function initVideoSlider(wrap) {
    if (!wrap || wrap.dataset.iuropVsliderReady === '1') return;
    wrap.dataset.iuropVsliderReady = '1';

    var row = wrap.querySelector('[data-iurop-vslider-track]');
    if (!row) return;
    var dashes = Array.prototype.slice.call(wrap.querySelectorAll('[data-iurop-vslider-dash]'));

    function pitch() {
      var first = row.children[0];
      if (!first) return 0;
      var cs = window.getComputedStyle(row);
      var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function clampIndex(i) {
      var last = row.children.length - 1;
      if (i < 0) return 0;
      return i > last ? last : i;
    }
    function activeIndex() {
      var p = pitch();
      if (!p) return 0;
      /* QA R17 · B5: al final del track el último ítem NO llega a su múltiplo
         exacto de pitch (el scroll topa antes) → si estamos en el tope, el
         activo es el último, no el penúltimo. */
      var max = row.scrollWidth - row.clientWidth;
      if (max > 0 && row.scrollLeft >= max - 2) return clampIndex(row.children.length - 1);
      return clampIndex(Math.round(row.scrollLeft / p));
    }
    function setActive(i) {
      for (var k = 0; k < dashes.length; k++) {
        dashes[k].classList.toggle('is-active', k === i);
      }
    }
    function sync() {
      setActive(activeIndex());
    }
    function goTo(i) {
      var p = pitch();
      if (!p) return;
      var max = row.scrollWidth - row.clientWidth;
      var left = clampIndex(i) * p;
      if (left > max) left = max;
      if (left < 0) left = 0;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* En pestaña oculta el scroll suave NO avanza (el pipeline de render está
         parado) → asignación directa. */
      if (reduced || document.hidden) {
        row.scrollLeft = left;
        sync();
      } else {
        row.scrollTo({ left: left, behavior: 'smooth' });
      }
      /* QA R17 · B5: marcar el destino YA, sin esperar a que el listener de
         scroll lo re-derive (con scroll suave llega tarde y el punto activo
         se quedaba en el anterior). */
      setActive(clampIndex(i));
    }

    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    dashes.forEach(function (dash, k) {
      dash.addEventListener('click', function () { goTo(k); });
    });
    sync();
  }

  /* ---------- P3a: aria-current de las miniaturas ----------
     El estado activo lo pone assets/iurop-product.js con la clase .is-active;
     aquí solo se ESPEJA en aria-current (sin él, un lector de pantalla anuncia
     siempre "imagen 1" como actual). Un 2º listener de click cancelaría al 1º,
     así que se observa la clase en vez de escuchar el click. */
  function initThumbsAria(box) {
    if (!box || box.dataset.iuropThumbsAria === '1') return;
    box.dataset.iuropThumbsAria = '1';
    var thumbs = Array.prototype.slice.call(box.querySelectorAll('[data-iurop-thumb]'));
    if (!thumbs.length) return;
    function sync() {
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', t.classList.contains('is-active') ? 'true' : 'false');
      });
    }
    new MutationObserver(sync).observe(box, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    sync();
  }

  /* ---------- P3b: "Leer más" solo cuando hay texto que desplegar ----------
     Si la reseña no llega a recortarse, el botón sobra y se oculta (misma
     solución que C3 en main-product-personalizar). El toggle de .is-expanded lo
     sigue haciendo assets/iurop-product.js: aquí NO se ata un 2º click, solo se
     espeja aria-expanded observando la clase de la tarjeta. */
  function initReadMore(root) {
    Array.prototype.slice
      .call((root || document).querySelectorAll('[data-iurop-leer-mas]'))
      .forEach(function (btn) {
        if (btn.dataset.iuropReadmoreReady === '1') return;
        btn.dataset.iuropReadmoreReady = '1';
        var card = btn.closest('[data-iurop-review-card]');
        var text = card && card.querySelector('[data-iurop-review-text]');
        if (!card || !text) return;

        function syncNeeded() {
          if (card.classList.contains('is-expanded')) { btn.hidden = false; return; }
          btn.hidden = (text.scrollHeight - text.clientHeight) <= 1;
        }
        new MutationObserver(function () {
          btn.setAttribute('aria-expanded', card.classList.contains('is-expanded') ? 'true' : 'false');
          syncNeeded();
        }).observe(card, { attributes: true, attributeFilter: ['class'] });

        syncNeeded();
        window.addEventListener('resize', syncNeeded, { passive: true });
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(syncNeeded).catch(function () {});
        }
      });
  }

  /* ---------- P3d: las tarjetas de vídeo, también con teclado ----------
     El click lo atiende assets/iurop-product.js; aquí solo se traduce
     Enter/Espacio a ese mismo click (la tarjeta ya es role="button"). */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    var card = event.target.closest && event.target.closest('[data-iurop-video]');
    if (!card) return;
    event.preventDefault();
    card.click();
  });

  /* "+info" de Mercado Pago: delegado en document (sobrevive al re-render del
     editor de temas). */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-iurop-mp-toggle]');
    if (!btn) return;
    var id = btn.getAttribute('aria-controls');
    var panel = id ? document.getElementById(id) : null;
    if (!panel) return;
    var open = panel.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  function boot() {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-iurop-vslider]'))
      .forEach(initVideoSlider);
    Array.prototype.slice
      .call(document.querySelectorAll('[data-iurop-thumbs]'))
      .forEach(initThumbsAria);
    initReadMore(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
